import { call } from 'redux-saga/effects';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import { fetchInventoryExportUrl as fetchInventoryExportUrlRoutine } from './routines';

export const fetchInventoryExportUrl = ({ payload: { type, options } }) =>
  sagaRoutineRequest(fetchInventoryExportUrlRoutine, {
    request: () => call(Api.fetchInventoryExportUrl, { type, options })
  });
